<template>
<button
  v-if="!isParticipant"
  v-show="showBackToTop"
  v-tooltip="`Scroll to top`"
  class="fixed btn-fixed-bottom-right"
  @click.prevent="goBackToTop"
  aria-label="Scroll to top"
>
  <i class="fas fa-arrow-up circle-icon lrg bg-gray-100" aria-hidden="true" />
</button>
</template>

<script>
export default {
  data() {
    return {
      scrollTop: null,
      innerHeight: null,
      showBackToTop: false
    };
  },
  computed:{
    isParticipant(){
      return this.$auth?.user?.isParticipant;
    },
  },
  mounted() {
    this.setupOnScroll();
    this.checkPosition();
  },
  destroyed() {
    window.removeEventListener('scroll', this.checkPosition);
  },
  methods: {
    setupOnScroll(){
      window.addEventListener('scroll', this.checkPosition);
    },
    checkPosition(){
      this.scrollTop = window.scrollY;
      this.innerHeight = window.innerHeight;
      this.showBackToTop = this.scrollTop > 300;
    },
    goBackToTop(){
      window.scroll({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-fixed-bottom-right {
  right: 30px;
  bottom: 30px;
  z-index: 10;
}
</style>
